
import React from 'react';

interface IzakayaBadgeBannerProps {
  lang: 'ja' | 'en';
}

const badges = {
  ja: [
    { icon: 'ri-map-pin-off-line', label: '観光客ゼロのエリア' },
    { icon: 'ri-user-heart-line', label: 'ガイド同行' },
    { icon: 'ri-goblet-line', label: '飲み代込み' },
    { icon: 'ri-store-2-line', label: '地元の常連店のみ' },
    { icon: 'ri-translate-2', label: '英語対応OK' },
    { icon: 'ri-group-line', label: '少人数制（最大6名）' },
    { icon: 'ri-moon-line', label: '夜の東京を体験' },
  ],
  en: [
    { icon: 'ri-map-pin-off-line', label: 'Zero Tourist Crowds' },
    { icon: 'ri-user-heart-line', label: 'Local Guide Included' },
    { icon: 'ri-goblet-line', label: 'Drinks Included' },
    { icon: 'ri-store-2-line', label: 'Locals-Only Bars' },
    { icon: 'ri-translate-2', label: 'English-Friendly' },
    { icon: 'ri-group-line', label: 'Small Group (Max 6)' },
    { icon: 'ri-moon-line', label: 'Authentic Tokyo Night' },
  ],
};

export const IzakayaBadgeBanner: React.FC<IzakayaBadgeBannerProps> = ({ lang }) => {
  const items = badges[lang];

  return (
    <div className="bg-amber-950 border-y border-amber-800/60 overflow-hidden">
      {/* Scrolling ticker on mobile, static grid on desktop */}
      <div className="hidden md:flex items-center justify-center gap-0 flex-wrap">
        {items.map((badge, i) => (
          <div
            key={i}
            className="flex items-center gap-2 px-6 py-4 border-r border-amber-800/40 last:border-r-0"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`${badge.icon} text-amber-400 text-base`}></i>
            </div>
            <span className="text-amber-100 text-sm font-medium whitespace-nowrap tracking-wide">
              {badge.label}
            </span>
          </div>
        ))}
      </div>

      {/* Mobile: auto-scrolling ticker */}
      <div className="md:hidden relative flex overflow-hidden">
        <div className="flex animate-marquee gap-0">
          {[...items, ...items].map((badge, i) => (
            <div
              key={i}
              className="flex items-center gap-2 px-5 py-3 border-r border-amber-800/40 flex-shrink-0"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${badge.icon} text-amber-400 text-sm`}></i>
              </div>
              <span className="text-amber-100 text-xs font-medium whitespace-nowrap tracking-wide">
                {badge.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
